export default __webpack_public_path__ + "static/media/Arte_305__Full_Body.e8608daf.png";